import { toast } from "react-toastify";
import { deleteFight } from "../../services/fightsAPI";
import { Button } from "../ui/btns/Button";
import { Modal } from "./Modal";
import { useState } from "react";

const DeleteFight = ({ fightID, isOpen, close, fetchGames, goBack }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await deleteFight(fightID);
      console.log("response", response);
      toast.success("Fight deleted successfully");
      if (goBack) {
        goBack();
      } else {
        window.location.reload();
      }
      close();
    } catch (error) {
      toast.error("Error deleting fight", { autoClose: 5000 });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Modal close={close} isOpen={isOpen} style={{ maxHeight: "200px" }}>
      <div className="p-4">
        <h3 className="text-2xl text-black">
          Are you sure you want to delete this fight # {fightID} ?{" "}
        </h3>
        {/* Add buttons, cancel and delete */}
        <div className="flex gap-4 justify-end mt-4">
          <Button onClick={close}>Cancel</Button>
          <Button onClick={handleDelete} disabled={isLoading}>
            {isLoading ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default DeleteFight;
